import { format } from 'date-fns';

export const getCurrentMonthName = (): string => {
  return format(new Date(), 'MMMM');
};
